import { connect } from 'react-redux';
import LanguageAndRegion from './LanguageAndRegion';

const mapStateToProps = state => ({
  loggedUserId: state.session.userId,
  user: state.users.details.user.details,
});

export default connect(mapStateToProps, null)(LanguageAndRegion);
